<script lang="ts">
  // libs
  import { authorizationCheck } from "@shared/svelte/Modules/AuthorizationCheck.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  // components
  import ViewOnlyBanner from "@retailer/svelte/Payments/Banners/ViewOnly.svelte";
  import DisabledBanner from "@retailer/svelte/Payments/Banners/Disabled.svelte";
  import AutoPayInfoBanner from "@retailer/svelte/Payments/Banners/AutoPayInfo.svelte";

  // stores
  import { dwollaIdentityStore, userDisabled } from "@retailer/svelte/stores/DwollaIdentityStore";

  // services
  import * as UserNotificationsService from "@retailer/services/user_notifications_service";

  // stores
  import { userNotifications } from "@retailer/stores/UserNotificationsStore";

  // data
  const autopayBannerType = "auto_pay_banner";
  const specsReadOnly = stagedRolloutCheck("specs_read_only_payments");

  // functions
  const createUserNotification = async type => {
    const data = {
      user_notification: {
        notification_type: type,
        seen_at: new Date(),
        retailer_id: window["$rootScope"].currentRetailerId,
      },
    };

    return await UserNotificationsService.create(data);
  };
  const handleBannerClose = async type => {
    switch (type) {
      case autopayBannerType:
        showAutoPayBanner = false;
        break;
    }
    await createUserNotification(type);
  };
  const userNotificationSeen = type =>
    $userNotifications.seen.find(n => n.notification_type == type);

  // reactives
  $: showAutoPayBanner = !userNotificationSeen(autopayBannerType) && !specsReadOnly;

</script>

{#if $dwollaIdentityStore.loaded}
  {#if !authorizationCheck("invoices.pay")}
    <ViewOnlyBanner />
  {:else if $userDisabled}
    <DisabledBanner />
  {:else if showAutoPayBanner}
    <AutoPayInfoBanner {handleBannerClose} />
  {/if}
{/if}
